import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const GoogleCallback: React.FC = () => {
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const fragment = new URLSearchParams(window.location.hash.substring(1));
    const idToken = fragment.get('id_token');
    const urlError = fragment.get('error');

    if (urlError) { setError(`Erro do Google: ${urlError}`); return; }
    if (!idToken) { setError('Token não recebido do Google.'); return; }

    login(idToken).then(() => {
      window.location.replace('/');
    }).catch(err => {
      setError(`Erro: ${err.message}`);
    });
  }, [login]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="bg-white rounded-xl shadow-lg p-8 text-center max-w-md">
          <p className="text-red-600 mb-4">{error}</p>
          <p className="text-xs text-gray-400 mb-4">Verifique o console do navegador (F12) para mais detalhes.</p>
          <button onClick={() => window.location.href = '/'} className="text-blue-600 hover:underline">
            Tentar novamente
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-600 mx-auto mb-4" />
        <p className="text-gray-600">Processando login...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
